/**
 * Permission Constants
 * Business logic constants for role-based restrictions
 */

export const PERMISSIONS = {
  OPERATOR_BILLET_MOVE_LIMIT: 17, // Fallback value when BYI_APP_OPERATOR_MAX_BILLETS setting is not available
  PROTECTED_LOCATIONS: {
    HOMELESS: 2,
    BIN: 32,
    SCRAP: 101,
  },
} as const;
